import { privateApi } from '@services/api';
import { HTTP_UNAUTHORIZED } from '@constants/httpStatus';

export default async function getUser() {
  try {
    const response = await privateApi.request({
      method: 'GET',
      url: '/user/me',
      withCredentials: true,
    });
    return response.data;
  } catch (error: any) {
    if (error?.status === HTTP_UNAUTHORIZED) {
      return {
        loggedIn: false,
      };
    }
    if (error?.response?.data) {
      return error.response.data;
    }
    // let caller handle
    throw error;
  }
}
